{
  "nav": {
    "label": "サイトのコンテンツ",
    "pages": "ページ",
    "policies": "ショップの規約",
    "menus": "メニュー",
    "redirects": "転送設定",
    "announcements": "お知らせ",
    "translations": "翻訳",
    "website_texts": "サイトの文言",
    "languages": "言語",
    "media": "画像とファイル"
  },
  "common": {
    "cancel": "キャンセル",
    "close": "閉じる",
    "delete": "削除",
    "edit": "編集",
    "save": "保存",
    "saving": "保存中…",
    "loading": "読み込み中…",
    "load_more": "もっと見る",
    "japan_time": "日本時間 (JST)"
  },
  "errors": {
    "generic": "問題が発生しました。もう一度お試しください。",
    "network": "サーバーに接続できません。インターネット接続を確認してください。",
    "forbidden": "このアカウントではこの操作はできません。オーナーに権限を依頼してください。",
    "version_conflict": "他の人が先に保存しました。",
    "if_match_required": "先に他の人が変更しました。再読み込みしてからもう一度お試しください",
    "handle_taken": "このURLは別のページで使われています。",
    "validation_failed": "正しくない値があります。強調表示された欄を確認してください。",
    "page_not_found": "このページはもうありません。",
    "page_trashed": "このページはゴミ箱にあります。先に元に戻してください。",
    "policy_incomplete": "必須の項目がまだ空です。",
    "menu_in_use": "このメニューはサイトで使われています。先にサイトのデザインから外してください。",
    "menu_depth_exceeded": "メニューは3階層までです。",
    "menu_too_large": "メニューの項目が多すぎます。",
    "redirect_exists": "この旧URLにはすでに転送があります。",
    "redirect_invalid": "旧URLまたは新URLが正しくありません。",
    "redirect_loop": "訪問者がぐるぐる回ってしまう設定です。",
    "redirect_chain_too_long": "転送が何段も続いています。旧URLを最終ページに直接向けてください。",
    "announcement_limit_exceeded": "お知らせが多すぎます。古いものを削除してください。",
    "locale_required": "英語（メインの言語）はオフにできません。",
    "translator_not_configured": "自動翻訳はまだオンになっていません。",
    "placeholder_mismatch": "{ } の中の言葉が英語の文と合っていません。",
    "icu_syntax_invalid": "閉じていない { または } があります。",
    "rate_limited": "一度に変更が多すぎます。少し待ってからお試しください。"
  },
  "unsaved": {
    "title": "保存せずに移動しますか？",
    "body": "この画面の変更はまだ保存されていません。",
    "leave": "変更を捨てて移動",
    "stay": "この画面に残る"
  },
  "locale": {
    "missing_sr": "（未翻訳）",
    "dots_label": "言語",
    "tabs_for": "{{label}}の言語",
    "english_required": "英語の文を入れてください。英語はサイトのメインの言語です。",
    "state": {
      "missing": "未翻訳",
      "draft": "要確認",
      "reviewed": "翻訳済み"
    }
  },
  "status": {
    "published": "公開中",
    "draft": "下書き",
    "scheduled": "予約",
    "scheduled_at": "{{time}}に公開",
    "trashed": "ゴミ箱"
  },
  "preview": {
    "loading": "プレビューを準備中…",
    "unavailable": "今はプレビューを表示できません（サイトが動いていない可能性があります）。",
    "open_new_tab": "新しいタブでプレビューを開く"
  },
  "pages": {
    "title": "ページ",
    "intro": "当店について・お問い合わせ・ランク基準などの案内ページです。",
    "new": "新しいページ",
    "search": "ページを検索",
    "search_placeholder": "名前またはURL",
    "filter": "表示",
    "filter_all": "すべて",
    "filter_published": "公開中",
    "filter_draft": "下書き",
    "filter_scheduled": "予約",
    "filter_trashed": "ゴミ箱",
    "empty": "まだページがありません。",
    "updated": "最終更新 {{time}}"
  },
  "page_editor": {
    "new_title": "新しいページ",
    "create": "ページを作成",
    "preview": "プレビュー",
    "preview_frame": "ページのプレビュー（下書き）",
    "languages": "言語",
    "side_by_side": "2つの言語を並べて比較",
    "side_hint": "左右の言語を選んでください。どちらも編集できます。",
    "side_left": "左",
    "side_right": "右",
    "title_label": "ページ名（{{language}}）",
    "body_label": "本文（{{language}}）",
    "copy_from_en": "英語からコピー",
    "copied": "英語の文を{{language}}にコピーしました。翻訳して確認してください。",
    "please_check": "コピー済み — 要確認",
    "visibility": "サイトに表示するタイミング",
    "mode_draft": "下書きのまま（サイトに出さない）",
    "mode_now": "今すぐサイトに表示",
    "mode_schedule": "日時を指定して表示",
    "publish_now": "今すぐ公開",
    "publish_at": "日時",
    "schedule": "この日時に公開",
    "unpublish": "サイトから外す",
    "cancel_schedule": "予約を取り消す",
    "trash": "ゴミ箱に移動",
    "trash_title": "このページをゴミ箱に移動しますか？",
    "trash_body": "サイトから消えます。あとでゴミ箱から元に戻せます。",
    "restore": "ゴミ箱から戻す",
    "restored": "ページを戻しました（下書き）。",
    "published_ok": "ページを公開しました。",
    "scheduled_ok": "指定した日時に公開されます。",
    "unpublished": "ページをサイトから外しました。",
    "schedule_cancelled": "予約を取り消しました。ページは下書きです。",
    "created_draft": "下書きとしてページを作成しました。",
    "created_now": "ページを作成して公開しました。",
    "created_schedule": "ページを作成しました。指定した日時に公開されます。",
    "saved": "保存しました。",
    "needs_english": "先に英語のページ名を入れてください。英語はサイトのメインの言語です。",
    "when_invalid": "日付と時刻を選んでください。",
    "settings": "ページの設定",
    "handle": "URL",
    "handle_hint": "小文字・数字・- のみ。例: about-us",
    "handle_invalid": "小文字 (a–z)・数字・- のみ使えます。例: rank-standards",
    "handle_taken": "このURLは別のページで使われています。",
    "handle_redirect": "保存すると、旧URL {{from}} を開いた人は新しいURLへ自動で転送されます。",
    "kind": "ページの種類",
    "kind_default": "一般ページ",
    "kind_contact": "お問い合わせページ（フォーム付き）",
    "kind_help": "ヘルプセンター",
    "kind_faq": "よくある質問",
    "kind_other": "ページの形「{{name}}」",
    "seo": "検索エンジン",
    "seo_title": "検索結果のタイトル",
    "seo_description": "検索結果の説明",
    "chars": "{{count}}文字（{{advice}}文字前後がおすすめ）",
    "google_sample": "Googleでの見え方",
    "conflict": "編集中に他の人がこのページを保存しました。",
    "conflict_reload": "相手の版を読み込む（自分の変更は消えます）",
    "conflict_overwrite": "自分の版で上書き",
    "warnings_title": "保存時に本文の一部が調整されました:"
  },
  "content_warning": {
    "unsupported_node": "サイトで表示できない部分を普通の文字にしました",
    "unsupported_mark": "サイトで表示できない文字の書式を外しました",
    "link_not_allowed": "使えないリンクを外しました",
    "image_src_not_media": "画像ライブラリ以外の画像を外しました。ライブラリから追加してください",
    "embed_not_allowed": "YouTube・Vimeo以外の動画を外しました",
    "other": "サイトで表示できないものを外しました"
  },
  "richtext": {
    "toolbar": "{{label}}の書式ツール",
    "style": "文字の種類",
    "paragraph": "普通の文",
    "h2": "大見出し",
    "h3": "見出し",
    "h4": "小見出し",
    "bold": "太字",
    "italic": "斜体",
    "underline": "下線",
    "strike": "取り消し線",
    "bullet": "箇条書き",
    "ordered": "番号付きリスト",
    "quote": "引用",
    "link": "リンク",
    "unlink": "リンクを外す",
    "image": "画像",
    "image_pick": "画像を選ぶ",
    "image_placeholder": "画像: {{name}}",
    "image_alt": "説明: {{alt}}",
    "image_no_alt": "説明がまだありません — 下に入れてください",
    "image_alt_label": "画像の説明（画像が見えない人のため）",
    "image_alt_hint": "何が写っているか書きます。例:「ピカチュウのカード ランクA 表面」",
    "video": "YouTube / Vimeo 動画",
    "video_url": "動画のURL",
    "video_invalid": "YouTube または Vimeo のURLを貼ってください。例: https://www.youtube.com/watch?v=…",
    "embed_placeholder": "{{provider}} 動画（{{id}}）",
    "table": "表",
    "table_tools": "表",
    "add_row": "行を追加",
    "add_column": "列を追加",
    "delete_row": "行を削除",
    "delete_column": "列を削除",
    "delete_table": "表を削除",
    "callout": "目立つ枠",
    "callout_kind": "枠の種類",
    "callout_info": "お知らせ",
    "callout_tip": "ヒント",
    "callout_warning": "注意",
    "callout_success": "うれしいお知らせ",
    "callout_note": "メモ",
    "rule": "区切り線",
    "more": "その他",
    "undo": "元に戻す",
    "redo": "やり直す",
    "link_address": "リンク先",
    "link_invalid": "https://、/（ショップのページ）、mailto: または tel: で始まるアドレスを使ってください。",
    "link_pick": "またはショップから選ぶ:",
    "pick_page": "案内ページ",
    "pick_policy": "規約ページ",
    "pick_collection": "カテゴリー",
    "pick_product": "商品",
    "choose": "選ぶ…",
    "new_tab": "新しいタブで開く",
    "apply": "適用",
    "insert": "挿入",
    "paste_images_dropped": "他のソフトから貼り付けた画像は残りません。「画像」ボタン（画像ライブラリ）から追加してください。"
  },
  "policies": {
    "title": "ショップの規約",
    "intro": "法律でショップに表示が求められるページです。開店前に足りない項目が分かります。",
    "edit": "開く",
    "complete": "そろっています",
    "missing_other": "{{count}}項目が未入力（{{languages}}）",
    "published": "公開中（第{{version}}版・{{time}}）",
    "not_published": "未公開",
    "unpublished_changes": "未公開の変更あり",
    "weight_law": "法律で必要",
    "weight_recommended": "おすすめ",
    "type": {
      "tokushoho": "特定商取引法に基づく表記",
      "privacy": "プライバシーポリシー",
      "terms": "利用規約",
      "returns": "返品特約",
      "shipping": "配送について",
      "kobutsu": "古物営業法に基づく表示",
      "contact": "お問い合わせ"
    },
    "legal": {
      "tokushoho": "通信販売では、販売者・支払方法・引渡時期・返品について表示が必要です。",
      "returns": "サイトへの表示が必要です。表示がないと、お客様は8日以内なら解除できます。",
      "privacy": "個人情報保護法（APPI）により、個人データの扱い（海外での保管を含む）を示します。",
      "kobutsu": "中古品を売買するショップは、古物商許可をサイトに表示します。",
      "terms": "サイトの利用と購入のルールです。",
      "shipping": "配送方法・配送先・海外のお客様が負担する費用です。",
      "contact": "お客様からの連絡方法です。"
    }
  },
  "policy_editor": {
    "unknown": "このページはありません。",
    "save_draft": "下書きを保存",
    "saved": "下書きを保存しました。公開するまでサイトには出ません。",
    "preview": "プレビュー",
    "preview_frame": "規約ページのプレビュー（下書き）",
    "shared_title": "全言語で共通",
    "shared_hint": "電話番号・メール・URL・許可番号は、全言語で一度だけ入力します。",
    "page_title": "ページ名（{{language}}）",
    "page_title_hint": "空欄なら標準の名前を使います。",
    "body": "本文（{{language}}）",
    "body_name": "ページの本文",
    "locale_required": "公開前に{{language}}の入力が必要です。",
    "locale_optional": "{{language}}は任意です。空の項目は英語で表示されます。",
    "required_in": "必須: {{languages}}",
    "example": "例: {{example}}",
    "missing_in": "未入力 — 公開前に{{language}}で入力してください。",
    "missing_shared": "未入力 — 公開前に入力してください。",
    "missing_title": "まだ足りない項目:",
    "missing_item": "{{language}}: {{field}}",
    "incomplete": "公開できません — 必須項目が空です（赤で表示）。",
    "publish_title": "公開",
    "note": "履歴用のメモ（任意）",
    "publish": "規約を公開",
    "publish_hint": "日本語と英語はすべて必要です。その他の言語はお知らせのみです。",
    "publish_needs_manager": "公開できるのはオーナーまたはマネージャーだけです。下書きを保存して伝えてください。",
    "published": "公開しました（第{{version}}版）。",
    "published_with_gaps": "公開しました（第{{version}}版）。未翻訳: {{languages}} — その言語では英語が表示されます。",
    "nothing_new": "新しく公開する内容はありません。",
    "suggest_payments": "支払方法を決済設定から取り込む",
    "suggested": "決済設定から入力しました。文言を確認してください。",
    "suggest_unavailable": "今は決済設定を読み込めません。支払方法を手で入力してください。",
    "checklist_title": "必須項目",
    "checklist_appi": "個人情報保護法（APPI）で必要な項目",
    "versions": "公開した版",
    "version_line": "第{{version}}版 · {{time}}",
    "no_versions": "まだ公開していません。",
    "placeholder": "まだ [[ ]] のサンプル文です。ショップの実際の情報に置き換えてください。"
  },
  "policy_fields": {
    "business_name": {
      "label": "販売業者",
      "hint": "販売する事業者の名称（登記どおり）。",
      "example": "株式会社〇〇 / TCG Shop Tokyo"
    },
    "representative": {
      "label": "運営統括責任者",
      "hint": "代表者または通販の責任者。",
      "example": "山田 太郎"
    },
    "address": {
      "label": "所在地",
      "hint": "事業所の住所（省略しない）。",
      "example": "〒150-0001 東京都渋谷区…"
    },
    "phone": {
      "label": "電話番号",
      "hint": "お客様がかけられる番号。",
      "example": "03-1234-5678"
    },
    "phone_hours": {
      "label": "電話受付時間",
      "hint": "電話に出られる時間。",
      "example": "10:00〜18:00（水曜定休）"
    },
    "email": {
      "label": "メールアドレス",
      "hint": "注文に関する問い合わせ先。",
      "example": "support@example.com"
    },
    "url": {
      "label": "URL",
      "hint": "このオンラインショップのアドレス。",
      "example": "https://shop.example.com"
    },
    "price_display": {
      "label": "販売価格",
      "hint": "税込表示であることと、表示場所。",
      "example": "各商品ページに税込価格で表示"
    },
    "additional_fees": {
      "label": "商品代金以外の必要料金",
      "hint": "送料・振込手数料・海外の関税など。",
      "example": "送料〇〇円〜、振込手数料はお客様負担"
    },
    "payment_methods": {
      "label": "支払方法",
      "hint": "使えるすべての支払方法。下のボタンでも入力できます。",
      "example": "銀行振込、店頭払い"
    },
    "payment_timing": {
      "label": "支払時期",
      "hint": "いつまでに支払うか。",
      "example": "ご注文から3日以内"
    },
    "delivery_timing": {
      "label": "商品の引渡時期",
      "hint": "入金後いつ発送するか。",
      "example": "入金確認後2営業日以内に発送"
    },
    "return_policy": {
      "label": "返品・交換について（返品特約）",
      "hint": "ショップの返品条件。表示がないと8日以内の解除が認められます。",
      "example": "トレーディングカードの性質上、…を除き返品不可"
    },
    "quantity_limit": {
      "label": "販売数量の制限",
      "hint": "購入できる数に制限があれば。",
      "example": "ほとんどのカードは1点もの"
    },
    "application_validity": {
      "label": "申込みの有効期限",
      "hint": "未入金の注文をいつまで保持するか。",
      "example": "3日以内にご入金がない場合はキャンセル"
    },
    "kobutsu_license": {
      "label": "古物商許可",
      "hint": "空欄なら「古物営業法に基づく表示」の内容を使います。",
      "example": "東京都公安委員会 第123456789012号"
    },
    "other_notes": {
      "label": "その他",
      "hint": "お客様に知らせたいこと。",
      "example": ""
    },
    "controller_name": {
      "label": "事業者の名称",
      "hint": "個人データの責任者。",
      "example": ""
    },
    "controller_address": {
      "label": "住所",
      "hint": "",
      "example": ""
    },
    "purposes": {
      "label": "利用目的",
      "hint": "例: 商品の発送、問い合わせへの回答、買取時の本人確認。",
      "example": ""
    },
    "disclosure_procedure": {
      "label": "開示・訂正・利用停止等の請求手続",
      "hint": "どこでどう請求できるか。",
      "example": ""
    },
    "security_measures": {
      "label": "安全管理措置",
      "hint": "データを保管する国（例: 米国の決済サービス）も書きます。",
      "example": ""
    },
    "foreign_transfer": {
      "label": "外国にある第三者への提供",
      "hint": "どの海外事業者に、どの国で提供するか。",
      "example": ""
    },
    "complaints_contact": {
      "label": "苦情・相談の申出先",
      "hint": "個人情報に関する窓口。",
      "example": ""
    },
    "final_sale_summary": {
      "label": "返品特約の要約（1行）",
      "hint": "商品ページと最終確認画面に表示されます。",
      "example": "説明と異なる商品のみ返品可"
    },
    "licensee_name": {
      "label": "氏名又は名称",
      "hint": "古物商許可証の名義。",
      "example": ""
    },
    "commission_name": {
      "label": "許可をした公安委員会",
      "hint": "許可を出した公安委員会。",
      "example": "東京都公安委員会"
    },
    "license_number": {
      "label": "許可証番号",
      "hint": "許可証に書かれた番号。",
      "example": "第123456789012号"
    },
    "notified_url": {
      "label": "届出URL",
      "hint": "警察に届け出たサイトのURL。",
      "example": "https://shop.example.com"
    },
    "hours": {
      "label": "受付時間",
      "hint": "",
      "example": "11:00〜20:00"
    },
    "line_url": {
      "label": "LINE",
      "hint": "ショップのLINE（あれば）。",
      "example": ""
    }
  },
  "menus": {
    "title": "メニュー",
    "intro": "サイトの上部と下部のメニューです。",
    "editor_intro": "項目を選ぶと編集できます。ドラッグまたは矢印で移動します（3階層まで）。",
    "item_count_other": "{{count}}項目",
    "new_name": "新しいメニューの名前",
    "new_placeholder": "例: フッター — ショップ",
    "create": "メニューを作成",
    "items": "メニューの項目",
    "add": "項目を追加",
    "empty": "まだ項目がありません。最初の項目を追加してください。",
    "keyboard_hint": "キーボード: Alt + ↑ / ↓ で移動、Alt + → で上の項目の下へ、Alt + ← で1階層上へ。",
    "tree_label": "メニューの項目",
    "children_of": "{{name}}の下の項目",
    "no_label": "（名前なし）",
    "drag": "{{name}}をドラッグして移動",
    "up": "上へ",
    "down": "下へ",
    "indent": "上の項目の下に入れる",
    "outdent": "1階層上へ",
    "add_child": "この下に項目を追加",
    "duplicate": "コピーを作成",
    "remove": "削除",
    "item_form": "メニューの項目",
    "pick_item": "左の項目を選ぶと編集できます。",
    "label": "名前",
    "link": "リンク先",
    "badge": "小さなラベル",
    "badge_hint": "任意。例: NEW、SALE",
    "image": "画像（大きなメニュー用）",
    "image_hint": "任意。大きなドロップダウンメニューとスマホで表示されます。",
    "image_pick": "画像を選ぶ",
    "image_change": "画像を変更",
    "image_remove": "画像を外す",
    "new_tab": "新しいタブで開く",
    "menu_name": "メニュー名",
    "handle": "サイトでは「{{handle}}」として使われます。",
    "saved": "メニューを保存しました。数秒でサイトに反映されます。",
    "problem_label": "英語の名前がありません",
    "fix_first_other": "保存前に{{count}}件の項目を直してください。",
    "too_many": "メニューの項目は最大{{max}}件です。",
    "delete": "メニューを削除",
    "delete_title": "このメニューを削除しますか？",
    "delete_body": "メニューとすべての項目が削除されます。",
    "in_use": "このメニューはサイトで使われています。先にサイトのデザインで別のメニューを選んでください。",
    "issues_title": "確認してください:",
    "ref_issue": {
      "not_found": "「{{target}}」はもうありません。",
      "unpublished": "「{{target}}」は公開されていません。この項目は非表示になります。",
      "deleted": "「{{target}}」は削除されました。",
      "handle_changed": "「{{target}}」のURLが変わりました。"
    },
    "warning": {
      "other": "動かない可能性のあるリンクがあります。"
    },
    "preview": "このメニューでのサイト",
    "preview_hint": "保存済みのメニューが表示されます。変更を見るには保存してください。",
    "preview_frame": "メニュー付きのサイトのプレビュー"
  },
  "link": {
    "kind": "リンクの種類",
    "target_collection": "カテゴリー",
    "target_filtered": "カテゴリー＋絞り込み（例: ランクAのみ）",
    "target_product": "商品",
    "target_page": "案内ページ",
    "target_policy": "規約ページ",
    "target_search": "検索",
    "target_url": "その他のアドレス",
    "target_none": "リンクなし（見出しのみ）",
    "pick_collection": "カテゴリーを選ぶ",
    "pick_product": "商品を選ぶ",
    "pick_page": "ページを選ぶ",
    "pick_policy": "規約ページを選ぶ",
    "filter_rank": "カードの状態（ランク）",
    "rank": "ランク{{rank}}",
    "filter_type": "商品の種類",
    "type_any": "すべて",
    "type_raw_single": "シングルカード（未鑑定）",
    "type_graded_single": "鑑定品",
    "type_sealed_product": "未開封品",
    "search_words": "検索する言葉",
    "search_placeholder": "例: ピカチュウ",
    "address": "アドレス",
    "goes_to": "リンク先: {{path}}",
    "problem_missing_target": "リンク先を選んでください。",
    "problem_url_invalid": "https:// または /（ショップのページ）で始まるアドレスを使ってください。"
  },
  "redirects": {
    "title": "転送設定",
    "intro": "URLが変わったとき、旧URLを開いた人を新しいURLへ案内します。",
    "tab_redirects": "転送",
    "tab_not_found": "見つからないURL (404)",
    "search": "検索",
    "source": "作成元",
    "source_all": "すべて",
    "source_manual": "手動",
    "source_auto": "自動",
    "source_import": "ファイルから",
    "add": "転送を追加",
    "add_title": "新しい転送",
    "edit_title": "転送を変更",
    "import": "ファイルから取り込む",
    "export": "ファイルでダウンロード",
    "from": "旧URL",
    "to": "新URL",
    "from_hint": "言語なしで。例: /products/old-card",
    "to_hint": "ショップのページ（/collections/pokemon）または https://…",
    "kind": "種類",
    "kind_301": "恒久的な移動（おすすめ）",
    "kind_302": "一時的",
    "hits": "利用回数",
    "actions": "操作",
    "pick": "選択",
    "pick_row": "{{from}}を選択",
    "off": "オフ",
    "switch_off": "オフにする",
    "switch_on": "オンにする",
    "created": "転送を追加しました。",
    "updated": "転送を変更しました。",
    "count_other": "{{count}}件",
    "empty": "まだ転送がありません。",
    "delete_picked": "選んだ{{count}}件を削除",
    "delete_title_other": "{{count}}件の転送を削除しますか？",
    "delete_body": "旧URLを開いた人には「ページが見つかりません」と表示されます。",
    "deleted_other": "{{count}}件削除しました。",
    "import_title": "ファイルから転送を取り込む",
    "import_intro": "from,to（と status）の列があるCSVファイル。まずチェックし、確定するまで保存されません。",
    "import_file": "ファイルを選ぶ",
    "import_paste": "…または内容を貼り付け",
    "import_check": "ファイルをチェック",
    "checking": "チェック中…",
    "import_back": "別のファイルを選ぶ",
    "import_confirm_other": "{{count}}行を取り込む",
    "import_summary": "{{total}}行: 取り込み可能 {{valid}}行、問題あり {{errors}}行（スキップ）",
    "import_running": "取り込み中… {{done}} / {{total}}",
    "import_errors_other": "問題のある行 {{count}}行",
    "import_failed": "取り込みが止まりました。何も変更されていません。もう一度お試しください。",
    "imported": "取り込み完了: 新規 {{created}}、変更 {{updated}}、スキップ {{skipped}}",
    "row": "行",
    "problem": "問題",
    "code": {
      "from_invalid": "旧URLが正しくありません（/ で始めてください）。",
      "locale_prefix": "先頭の言語（/ja/…）は入れないでください。",
      "system_route": "このURLはショップのシステム用なので転送できません。",
      "to_invalid": "新URLが正しくありません。",
      "status_invalid": "種類は301か302です。",
      "duplicate_in_file": "この旧URLがファイル内に2回あります。",
      "redirect_loop": "訪問者がぐるぐる回ってしまいます。",
      "redirect_chain_too_long": "転送が何段も続いています。",
      "self_redirect": "旧URLと新URLが同じです。",
      "other": "この行は取り込めません。"
    },
    "not_found_intro": "お客様が開いたけれど存在しないURLです。役に立つページへ案内しましょう。",
    "not_found_empty": "見つからないURLはありません。",
    "not_found_count_other": "{{count}}回開かれました · 最終 {{time}}",
    "create_for": "このURLを転送する",
    "dismiss": "非表示"
  },
  "announcements": {
    "title": "お知らせ",
    "intro": "サイト上部のバーに出る短いメッセージです。",
    "add": "新しいお知らせ",
    "add_title": "新しいお知らせ",
    "edit_title": "お知らせを変更",
    "empty": "まだお知らせがありません。",
    "created": "お知らせを追加しました。",
    "saved": "お知らせを保存しました。",
    "conflict": "他の人がこのお知らせを変更しました。閉じてもう一度開いてください。",
    "text": "メッセージ",
    "text_hint": "200文字まで。",
    "text_required": "メッセージを入れてください。",
    "link": "クリックしたときの移動先",
    "starts": "開始",
    "starts_hint": "日本時間。空欄 = 今から",
    "ends": "終了",
    "ends_hint": "日本時間。空欄 = オフにするまで",
    "ends_before_starts": "終了は開始より後にしてください。",
    "languages": "表示する言語",
    "all_languages": "すべての言語",
    "only_languages": "{{languages}}のみ",
    "markets": "表示するお客様の国",
    "all_markets": "すべての国",
    "only_markets": "{{markets}}のみ",
    "market_JP": "日本",
    "market_US": "アメリカ",
    "market_EU": "ヨーロッパ",
    "market_UK": "イギリス",
    "market_TW": "台湾",
    "market_HK": "香港",
    "market_SG": "シンガポール",
    "market_TH": "タイ",
    "market_ROW": "その他の国",
    "colors": "色",
    "colors_default": "バーの標準の色",
    "scheme": "カラーセット {{n}}",
    "active": "オン",
    "on": "オン",
    "off": "オフ",
    "switch": "「{{text}}」を表示",
    "state_live": "表示中",
    "state_live_until": "表示中 · {{time}}まで",
    "state_scheduled": "予約",
    "state_scheduled_at": "{{time}}から表示",
    "state_ended": "終了",
    "state_inactive": "オフ",
    "sample": "バーの見本",
    "sample_language": "見本の言語",
    "sample_empty": "ここにメッセージが表示されます",
    "preview_site": "サイトで見る（保存済みのお知らせ）",
    "preview_frame": "お知らせバー付きのサイトのプレビュー",
    "delete_title": "このお知らせを削除しますか？",
    "delete_body": "サイトから消えます。"
  },
  "translations": {
    "title": "翻訳",
    "intro": "サイトのすべての文を、すべての言語で。未翻訳を絞り込んで入力します。",
    "progress": "言語ごとの翻訳状況",
    "progress_of": "{{language}}の翻訳",
    "progress_text": "{{total}}件中{{translated}}件 · 残り{{missing}}件",
    "language": "言語",
    "kind": "種類",
    "kind_all": "すべて",
    "kind_page": "ページ",
    "kind_policy": "規約",
    "kind_menu": "メニュー",
    "kind_announcement": "お知らせ",
    "kind_theme": "サイトのデザインの文",
    "kind_ui_strings": "サイトの文言（ボタン・ラベル）",
    "kind_media": "画像の説明",
    "search": "検索",
    "missing_only": "未翻訳のみ",
    "copied_only": "コピー／要確認のみ",
    "save_other": "{{count}}件を保存",
    "suggest_other": "選んだ{{count}}件を自動翻訳",
    "suggested": "{{count}}件の翻訳案を入れました。保存前に確認してください。",
    "mt_off": "自動翻訳はまだオンになっていません。手で翻訳してください。",
    "export_csv": "CSVをダウンロード",
    "export_json": "JSONをダウンロード",
    "import": "CSVをアップロード",
    "import_ready": "ファイルの準備ができました。",
    "import_check": "ファイルをチェック",
    "import_summary": "{{total}}行: 変更 {{changed}}、同じ {{unchanged}}、問題あり {{skipped}}",
    "import_row": "{{row}}行目: ",
    "import_confirm_other": "{{count}}件を保存",
    "imported": "取り込み完了: 変更 {{changed}}、スキップ {{skipped}}",
    "saved_other": "翻訳を{{count}}件保存しました。",
    "saved_publish_other": "翻訳を{{count}}件保存しました。表示するには規約ページ{{policies}}件の公開が必要です。",
    "count_other": "{{count}}件表示 · {{language}}の未翻訳 {{missing}}件",
    "all_done": "すべて翻訳済みです。",
    "empty": "見つかりません。",
    "table_label": "{{language}}の文",
    "col_what": "場所",
    "col_english": "英語",
    "pick_row": "{{what}}を選択",
    "edit_label": "{{what}}（{{language}}）",
    "status_missing": "未翻訳",
    "status_draft": "要確認",
    "status_reviewed": "翻訳済み",
    "copy_en": "英語をコピー",
    "rich_has": "書式付きの文 — 翻訳済み",
    "rich_missing": "書式付きの文 — 未翻訳",
    "rich_edit": "専用の画面で編集",
    "website_texts_link": "サイトの文言（ボタン・ラベル）→",
    "resource": {
      "page": "ページ",
      "policy": "規約",
      "menu": "メニュー",
      "announcement": "お知らせ",
      "template": "サイトのデザイン",
      "section_group": "サイトのデザイン",
      "ui_strings": "サイトの文言",
      "media": "画像"
    },
    "import_error": {}
  },
  "ui_strings": {
    "title": "サイトの文言",
    "intro": "サイトのボタン・ラベル・メッセージです。{ } の中の言葉はサイトが入れるので、英語と同じにしてください。",
    "groups": "文言のグループ",
    "search": "キーまたは文で検索",
    "count_other": "{{count}}件",
    "empty": "見つかりません。",
    "table_label": "{{language}}のサイトの文言",
    "edit_label": "{{key}}（{{language}}）",
    "core": "標準",
    "saved_other": "{{count}}件保存しました。",
    "fix_first_other": "保存前に赤い{{count}}件を直してください。",
    "unknown_placeholder": "{{names}} は英語の文にありません。サイトにそのまま表示されてしまいます。",
    "missing_placeholder": "英語の文にある {{names}} がありません。",
    "icu": {
      "unclosed": "{ が } で閉じられていません。",
      "unopened": "対応する { がない } があります。表示したいときは ' で囲んでください。",
      "double_braces": "名前は { } 1組で囲みます（2組ではありません）。",
      "name_expected": "{ の後に名前が必要です。",
      "format_expected": "カンマの後に形式（number, date, plural …）が必要です。",
      "unknown_format": "「{{detail}}」は知らない形式です。",
      "choice_unsupported": "「choice」は使えません。plural か select を使ってください。",
      "plural_choice": "「{{detail}}」は plural の選択肢ではありません（zero, one, two, few, many, other, =N）。",
      "choice_expected": "選択肢（{…}）が必要です。",
      "choice_twice": "選択肢「{{detail}}」が2回あります。",
      "other_required": "選択肢「other」が必要です。",
      "too_deep": "入れ子が深すぎます。",
      "unexpected": "ここに「{{detail}}」は置けません。",
      "brace_in_style": "形式の中に { は使えません。"
    },
    "problem": {
      "placeholder_mismatch": "{ } の中の言葉が英語と合っていません。",
      "placeholder_missing": "英語の { } の言葉が抜けています。",
      "icu_syntax_invalid": "{ または } に問題があります。",
      "translations_outdated": "英語の文が変わりました。翻訳を確認してください。"
    },
    "ns": {
      "common": "共通",
      "header": "サイト上部",
      "footer": "サイト下部",
      "home": "トップページ",
      "product": "商品ページ",
      "rank": "カードのランクA–D",
      "collection": "カテゴリーページ",
      "filters": "絞り込み",
      "search": "検索",
      "cart": "カート",
      "checkout": "ご注文手続き",
      "payment": "お支払い",
      "tracking": "注文の追跡",
      "account": "お客様アカウント",
      "policies": "規約",
      "errors": "エラーメッセージ",
      "a11y": "読み上げソフト用",
      "seo": "検索エンジン"
    }
  },
  "languages": {
    "title": "言語",
    "intro": "サイトで表示する言語と、訪問者に言語をどう案内するか。",
    "list": "サイトの言語",
    "needs_manager": "言語を変えられるのはオーナーまたはマネージャーだけです（サイトがすぐ変わります）。",
    "default": "メインの言語",
    "on": "オン",
    "off": "オフ",
    "shown": "サイトに表示",
    "hidden": "表示しない",
    "switch": "{{language}}をサイトに表示",
    "default_locked": "常にオン — メインの言語です。",
    "translated": "{{percent}}% 翻訳済み",
    "go_translate": "足りない翻訳をする",
    "turned_on": "{{language}}をサイトに表示しました。",
    "turned_off": "{{language}}の表示をやめました。",
    "off_title": "{{language}}の表示をやめますか？",
    "off_body": "訪問者は{{language}}のページに案内されなくなり、検索エンジンにも出なくなります。文は保存されたままで、あとでオンに戻せます。",
    "off_confirm": "表示をやめる",
    "default_title": "メインの言語",
    "default_value": "{{language}}（固定）",
    "default_reason": "メインの言語は英語のままです。言語なしのURLや検索エンジンがこの言語に依存しているためです。未翻訳の部分は他の言語でも英語で表示されます。",
    "detection_title": "初めての訪問",
    "detection_intro": "初めてサイトを開いた人に対して:",
    "mode_auto_redirect": "訪問者の言語を自動で開く",
    "mode_auto_redirect_effect": "日本のお客様は最初に日本語のページへ自動で案内されます。選んだ言語は記憶されます。",
    "mode_banner": "訪問者の言語をおすすめする",
    "mode_banner_effect": "ページは英語のまま、「日本語で見ますか？」という小さなバーを出します。",
    "mode_off": "何もしない",
    "mode_off_effect": "開いたURLのまま表示し、言語はお客様が自分で切り替えます。",
    "mode_saved": "保存しました。新しい訪問者から使われます。",
    "conflict": "他の人が同時に言語を変更しました。最新の設定を表示しています。もう一度お試しください。"
  },
  "media": {
    "title": "画像とファイル",
    "intro": "サイトの画像をまとめて管理します。パソコンやスマホからアップロードし、短い説明を付け、どこで使われているか確認できます。",
    "focal_label": "表示を優先する部分",
    "focal_value": "左から {{x}}、上から {{y}}",
    "focal_set": "画像が切り取られるときも、この点は表示されます。",
    "focal_hint": "画像のいちばん大事な部分（カードなど）をタップすると、切り取られても表示されます。",
    "focal_clear": "中央に戻す",
    "folder": "フォルダ",
    "folders": "フォルダ",
    "all_files": "すべての画像とファイル",
    "folder_name_needed": "フォルダの名前を入力してください。",
    "folder_name_taken": "同じ名前のフォルダがすでにあります。",
    "folder_failed": "フォルダを変更できませんでした。もう一度お試しください。",
    "folder_too_deep": "フォルダは5階層までです。",
    "folder_new": "新しいフォルダ",
    "folder_rename": "名前を変更",
    "folder_delete": "フォルダを削除",
    "folder_new_inside": "「{{name}}」の中に作るフォルダの名前",
    "folder_new_top": "新しいフォルダの名前",
    "folder_rename_label": "フォルダの新しい名前",
    "folder_top": "（フォルダなし）",
    "folder_deleted_other": "フォルダを削除しました。画像 {{count}} 件を1つ上に移しました。",
    "folder_has_folders": "先に中のフォルダを削除してください。",
    "folder_delete_title": "このフォルダを削除しますか？",
    "folder_delete_body": "中の画像は削除されず、1つ上のフォルダに移ります。",
    "detail_failed": "この画像の詳細を読み込めませんでした。",
    "saved": "保存しました。",
    "save_media_down": "画像サービスが応答しないため保存されませんでした。少し待ってからお試しください。",
    "save_forbidden": "画像を変更する権限がありません。管理者に依頼してください。",
    "save_failed": "保存できませんでした。もう一度お試しください。",
    "remove_failed": "画像を削除できませんでした。もう一度お試しください。",
    "untitled": "名前のない画像",
    "detail_close": "詳細を閉じる",
    "open_file": "ファイルを開く",
    "alt_title": "画像の説明",
    "alt_hint": "画像に何が写っているかを短く書きます。検索エンジンや画像が見えない方が読みます。",
    "alt_missing_en": "この画像には英語の説明がまだありません。サイトで使う前に入力してください。",
    "alt_missing": "未入力：{{languages}}",
    "alt_needed": "必須",
    "alt_placeholder": "例：ブラッキーVMAX カード 表面",
    "tags": "タグ",
    "tag_remove": "タグ {{tag}} を外す",
    "tags_placeholder": "タグを入力して Enter",
    "save": "変更を保存",
    "discard": "変更を取り消す",
    "used_where": "使用している場所",
    "used_nowhere": "まだどこにも使われていません。",
    "in_use_title": "この画像はまだサイトで使われています",
    "in_use_body": "先に次の場所を別の画像に変えてから削除してください：",
    "remove": "画像を削除",
    "remove_title": "この画像を一覧から削除しますか？",
    "remove_body": "一覧から非表示になります。サイトで使用中の画像は削除できません。",
    "use_template": "サイトのデザイン — 「{{page}}」ページ",
    "use_group": "サイトのデザイン — {{area}}",
    "use_settings": "サイトのデザイン — ロゴ／アイコン",
    "use_page": "ページ「{{name}}」",
    "use_policy": "ショップの規約 — {{name}}",
    "use_menu": "メニュー「{{name}}」",
    "use_live": "サイトに表示中",
    "use_draft": "下書きのみ",
    "search": "画像を検索",
    "search_placeholder": "名前・説明・タグ",
    "tag": "タグ",
    "tag_any": "すべてのタグ",
    "kind": "種類",
    "kind_any": "すべて",
    "kind_image": "画像",
    "kind_video": "動画",
    "kind_file": "ファイル（PDF）",
    "upload": "画像をアップロード",
    "upload_files": "ファイルをアップロード",
    "camera": "写真を撮る",
    "upload_rules": "JPEG・PNG・WebP・GIF・HEIC（iPhone）、1枚25MBまで。ここにドラッグしても追加できます。",
    "upload_rules_file": "画像は25MBまで、PDFは20MBまで。ここにドラッグしても追加できます。",
    "video_links": "動画はパーツの中で YouTube / Vimeo のリンクとして追加します。",
    "list_failed": "画像を読み込めませんでした。",
    "retry": "もう一度",
    "none_found": "「{{q}}」は見つかりませんでした。",
    "empty": "まだ画像がありません。最初の1枚をアップロードしてください。",
    "count_other": "画像 {{count}} 件",
    "results": "画像",
    "detail": "画像の詳細",
    "no_alt_badge": "説明なし",
    "picked": "選択中",
    "uploads": "アップロード",
    "uploads_busy_other": "{{count}} 件アップロード中…",
    "uploads_done_other": "{{count}} 件アップロードしました。",
    "uploads_clear": "一覧を消す",
    "problem": {
      "type": "この種類のファイルは使えません。JPEG・PNG・WebP・GIF・HEIC を使ってください。",
      "too_large": "ファイルが大きすぎます（画像は25MBまで）。",
      "empty": "ファイルが空です。",
      "network_error": "接続が切れました。インターネットを確認してもう一度お試しください。",
      "processing_timeout": "画像の準備に時間がかかっています。自動で表示されるか、もう一度お試しください。",
      "mime_mismatch": "ファイルの中身が名前の種類と違います。",
      "unsupported_media_type": "この種類のファイルは使えません。",
      "size_mismatch": "ファイルが最後まで届きませんでした。もう一度お試しください。",
      "corrupt_file": "ファイルが壊れていて開けません。",
      "processing_failed": "画像を準備できませんでした。もう一度アップロードしてください。",
      "pdf_invalid": "PDF を開けません。",
      "file_too_large": "ファイルが大きすぎます。",
      "upload_quota_exceeded": "一度にアップロードが多すぎます。少し待ってからお試しください。",
      "upload_not_received": "ファイルが届きませんでした。もう一度お試しください。",
      "purpose_not_allowed": "この種類のファイルはここにはアップロードできません。",
      "forbidden": "アップロードする権限がありません。管理者に依頼してください。",
      "other": "ファイルをアップロードできませんでした。"
    },
    "upload_status": {
      "waiting": "待機中",
      "uploading": "送信中",
      "processing": "準備中",
      "ready": "完了",
      "failed": "送信できず",
      "rejected": "受け付けられず",
      "cancelled": "中止"
    },
    "upload_cancel": "{{name}} のアップロードを中止",
    "upload_progress": "{{name}} のアップロード",
    "picker_hint": "画像を選ぶか、新しくアップロードします。タップしてから「この画像を使う」を押してください。",
    "picker_hint_many": "画像を1枚以上選ぶか、新しくアップロードします。",
    "picked_count_other": "{{count}} 件選択中",
    "use_many_other": "{{count}} 枚の画像を使う",
    "use_picture": "この画像を使う",
    "use_file": "このファイルを使う",
    "alt_off": "まだ公開していない言語"
  }
}
